import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import MailLayout from "./layouts/Main.vue";
import SelectProvider from "./views/provider/SelectProvider";
import Error404 from "./views/Error404.vue";
import OrderList from "./views/order/List.vue";
import CreateOrder from "./views/order/Create.vue";
import EditOrder from "./views/order/Edit.vue";
import ProductListForEdit from "./views/product/ListForEdit.vue";
import ShopSettings from "./views/shopSettings/ShopSettings.vue";
import ProviderProfile from "./views/provider/Profile/ProviderProfile";
import QrCodeGenerator from "./views/qrCodeGenerator/QrCodeGenerator";
import CustomerClub from "./views/customerClub/CustomerClub";
import ProviderEmployees from "./views/employees/ProviderEmployees";
import ProviderPackage from "./views/provider/ProviderPackage";
import DeliveryComponent from "./views/delivery/DeliveryComponent";
import WorkingHours from "./views/workingHours/WorkingHours";
import Coupons from "./views/coupons/Coupons";
import Tickets from "./views/tickets/Tickets";
import Details from "./views/tickets/details/Details";
import Tables from "./views/tables/Tables";
import Create from "./views/tickets/create/Create";

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: MailLayout,
      children: [
        {
          path: "/",
          redirect: "/order/list",
        },
        {
          path: "/order/list",
          component: OrderList,
        },
        {
          path: "/order/create",
          component: CreateOrder,
        },
        {
          path: "/order/edit/:info",
          component: EditOrder,
        },
        {
          path: "/shop-settings",
          component: ShopSettings,
        },
        {
          path: "/provider-profile",
          component: ProviderProfile,
        },
        {
          path: "/qrcode-generator",
          component: QrCodeGenerator,
        },
        {
          path: "/products",
          component: ProductListForEdit,
        },
        {
          path: "/customer-club",
          component: CustomerClub,
        },
        {
          path: "/select-provider/:id",
          component: SelectProvider,
        },
        {
          path: "/provider-employees",
          component: ProviderEmployees,
        },
        {
          path: "/provider-package",
          component: ProviderPackage,
        },
        {
          path: "/delivery",
          component: DeliveryComponent,
        },
        {
          path: "/hours",
          component: WorkingHours,
        },
        {
          path: "/coupons",
          component: Coupons,
        },
        {
          path: "/tickets",
          component: Tickets,
        },
        {
          path: "/tickets/create",
          component: Create,
        },
        {
          path: "/tickets/:id",
          component: Details,
        },
        {
          path: "/tables",
          component: Tables,
        },
      ],
    },
    {
      path: "/404",
      component: Error404,
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
});

router.afterEach(() => {
  const appLoading = document.getElementById("loading-bg");

  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
